export default __webpack_public_path__ + "assets/entertainment-curve.f6d2e4f7.svg";